/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WithdrawalDetailsResponse { 
    availableToWithdraw: number;
    transactionFee: number;
    remainingBalance: number;
    withdrawalAmount: number;
    withdrawalAmountInUsd: number;
}

